import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const PregnantPartnerIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="M16.9 10.4c-1.7 0-3.4.5-4.9 1.4-1.5-.9-3.2-1.3-4.9-1.4-2.2 0-6.6 1.3-6.6 3.8v9.3h23v-9.4c0-2.5-4.4-3.7-6.6-3.7zm-3.4 9.3L12 21.1c-.8.8-2.1.8-3 0l-.7-.7-.7.7c-.5.4-1.1.3-1.5-.2-.3-.4-.3-.9 0-1.2l1.5-1.5a1 1 0 0 1 1.5 0l.7.7 1.5-1.5-.7-.7a1 1 0 0 1 0-1.5 1 1 0 0 1 1.5 0l1.5 1.5c.7.8.7 2.1-.1 3zm3.3-3.4c-.6.6-1.6.5-2.2-.1-.5-.6-.5-1.5 0-2.1.6-.6 1.6-.5 2.2.1.5.6.5 1.5 0 2.1zm.1-7.7c1.8 0 3.3-1.5 3.3-3.3 0-1.8-1.5-3.3-3.3-3.3a3.3 3.3 0 0 0-3.3 3.3c0 1.8 1.5 3.3 3.3 3.3zm-9.8 0a3.2 3.2 0 1 0 .1-6.5 3.2 3.2 0 0 0-3.3 3.2 3.2 3.2 0 0 0 3.2 3.3z" />
    </IconBase>
  );
};

export default PregnantPartnerIcon;
